import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type Props = {
	id?: string;
	className?: string;
	children: React.ReactNode;
	showTooltip?: boolean;
	tooltipTrigger?: React.ReactNode;
	tooltipContent?: React.ReactNode;
};

export const Label = ({
	id,
	className,
	children,
	showTooltip,
	tooltipTrigger,
	tooltipContent,
}: Props) => {
	return (
		<label
			htmlFor={id}
			className={cn(
				"mb-2 block text-sm font-medium leading-6 text-gray-900",
				showTooltip ? "flex items-center justify-start gap-x-2" : "",
				className
			)}
		>
			{children}

			{showTooltip ? (
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger type="button" className="outline-gray-400">
							{tooltipTrigger}
						</TooltipTrigger>
						<TooltipContent className="max-w-sm bg-white text-gray-800">{tooltipContent}</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			) : null}
		</label>
	);
};
